import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { clsx } from "clsx";
import { emitStartGame } from "../../reducers/gameSlice";
import CloseIcon from "../../icons/close.svg";

function CreateGame(props) {
	const dispatch = useDispatch();

	const claimLimit = 210;
	const [mainClaim, setMainClaim] = useState("");
	const [displayLimit, setDisplayLimit] = useState(claimLimit);

	const isMainClaimValid = mainClaim.length >= 20 ? true : false;

	function handleMainClaim(event) {
		setMainClaim(event.target.value);
		setDisplayLimit(claimLimit - event.target.value.length);
	}

	function createGame() {
		if (isMainClaimValid) {
			dispatch(
				emitStartGame({
					mainClaim: mainClaim,
				}),
			);
		}
	}

	return (
		<div className={props.modalStyle.container}>
			<div className={props.modalStyle.closeContainer} onClick={props.closeModal}>
				<CloseIcon className={props.modalStyle.closeIcon} />
			</div>
			<div className="flex flex-col w-full h-7/10 justify-evenly">
				<h1 className="text-3xl font-medium text-gray-600">Create a Game</h1>
				<div className="flex flex-col">
					<div className="h-full text-center">
						<div>
							<span className="text-lg font-medium">Main Claim ({displayLimit})</span>
							<label className="block">
								<textarea
									className={clsx(
										"block w-9/10 lg:w-8/10 h-64 lg:h-32 resize-none bg-white whitespace-normal p-2 mt-2 mx-auto overflow-hidden rounded-md outline focus:outline-3 outline-blue-600",
										mainClaim.length > 0 && !isMainClaimValid ? "outline-red-600" : "",
									)}
									onChange={handleMainClaim}
									maxLength={claimLimit}
									placeholder="State your main claim"></textarea>
							</label>
							{mainClaim.length > 0 && !isMainClaimValid ? (
								<div className="mt-2 text-red-600 text-xs">Main Claim must contain at least 20 characters</div>
							) : null}
							<button
								disabled={!isMainClaimValid}
								className={clsx(
									"px-10 py-3 mt-5 text-base font-bold text-white  w-52 rounded-lg",
									isMainClaimValid
										? "bg-blue-500 hover:bg-blue-600 cursor-pointer"
										: "bg-blue-800 hover:bg-blue-900 cursor-not-allowed",
								)}
								onClick={createGame}>
								Start Game
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default CreateGame;
